import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import Button from "components/CustomButtons/Button.js";
import "./style.scss";

export default function Header() {
  const bg = {
    backgroundColor: `#319795`
  }
  return (
    <div className="header">
      <Navbar bg="transparent" expand="lg" variant="dark" className="container">
        <Navbar.Brand className="header__logo">
          <Link to="/">CAPUCHIN</Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <a
              href="https://www.capuchin.org.ng/vocations.php"
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
              className="links"
            >
              {" "}
              Parent website{" "}
            </a>{" "}
            <Button color="success" component={Link} to="/login" style={bg}>
              Login
            </Button>{" "}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}
